export const calculateDeliveryTime = (userLoc, vendorLoc) => {
  if (!userLoc || !vendorLoc || !userLoc.lat || !vendorLoc.lat) {
    return { text: "25 - 35 min", isFast: false };
  }
  
  const R = 6371; // Earth's radius in km
  const dLat = (vendorLoc.lat - userLoc.lat) * (Math.PI / 180);
  const dLon = (vendorLoc.lng - userLoc.lng) * (Math.PI / 180);
  const a = 
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(userLoc.lat * (Math.PI / 180)) * Math.cos(vendorLoc.lat * (Math.PI / 180)) * 
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in km
  
  // Assume 3 mins per km (20 km/h) + 15 mins base preparation time
  const minTime = Math.max(15, Math.floor((distance * 3) + 15));
  const maxTime = minTime + 10;
  
  return { 
    text: `${minTime} - ${maxTime} min`, 
    isFast: maxTime <= 30 
  };
};

export const getClosingTime = (workingHours) => {
  if (!workingHours) {
    return "Not available";
  }
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const dayName = days[new Date().getDay()];
  
  const hoursToday = workingHours[dayName];

  if (!hoursToday || !hoursToday.isOpen) {
    return "Closed today";
  }

  return hoursToday.close || "Not available";
};

export const isClosedToday = (workingHours) => {
  if (!workingHours) return false;
  
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const dayName = days[new Date().getDay()];
  const hoursToday = workingHours[dayName];
  
  if (!hoursToday || !hoursToday.isOpen) return true;
  
  const now = new Date();
  const currentHours = now.getHours();
  const currentMinutes = now.getMinutes();
  const currentMinutesTotal = currentHours * 60 + currentMinutes;
  
  const parseTimeToMinutes = (timeStr) => {
    if (!timeStr) return null;
    const cleaned = timeStr.trim().toUpperCase();
    const isPM = cleaned.includes('PM');
    const isAM = cleaned.includes('AM');
    
    const numbersOnly = cleaned.replace(/[A-Z\s]/g, '');
    const parts = numbersOnly.split(':');
    if (parts.length < 2) return null;
    
    let hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    
    if (isPM && hours < 12) hours += 12;
    if (isAM && hours === 12) hours = 0;
    
    return hours * 60 + minutes;
  };
  
  const openMinutes = parseTimeToMinutes(hoursToday.open);
  const closeMinutes = parseTimeToMinutes(hoursToday.close);
  
  if (openMinutes === null || closeMinutes === null) return false;
  
  if (closeMinutes < openMinutes) {
    // Over-midnight case (e.g. 18:00 to 02:00)
    return currentMinutesTotal >= closeMinutes && currentMinutesTotal < openMinutes;
  } else {
    // Same-day case (e.g. 08:00 to 22:00)
    return currentMinutesTotal < openMinutes || currentMinutesTotal >= closeMinutes;
  }
};